<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="sidenavMode" [opened]="isBigScreen" [fixedInViewport]="true" [class.nav-rail]="isRail">
    <mat-toolbar color="primary" class="nav-head">
      <span class="nav-label">Menu</span>
      @if (isBigScreen) {
        <button mat-icon-button type="button" class="nav-rail-toggle" (click)="toggleRail()"
                [attr.aria-label]="isRail ? 'Expand menu' : 'Collapse menu'"
                [matTooltip]="isRail ? 'Expand menu' : 'Collapse menu'" matTooltipPosition="right">
          <mat-icon>{{ isRail ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
      }
    </mat-toolbar>
    @if (admin) {
      <input
        #navFilter
        class="nav-filter"
        type="search"
        placeholder="Find a section (/)"
        aria-label="Filter menu"
        [value]="query"
        (input)="query = $any($event.target).value"
        (keydown.escape)="query = ''"
      >
      <mat-nav-list>
        @if (pinnedItems.length) {
          <h3 matSubheader>Pinned</h3>
          <div
            cdkDropList
            cdkDropListOrientation="vertical"
            class="pinned-list"
            [cdkDropListDisabled]="filtering"
            (cdkDropListDropped)="dropPinned($event)"
          >
            @for (item of pinnedItems; track item.link) {
              <ng-container *ngTemplateOutlet="navItem; context: { $implicit: item, draggable: !filtering }"></ng-container>
            }
          </div>
        }
        @for (group of groupsView; track group.title) {
          @if (filtering) {
            <h3 matSubheader>{{ group.title }}</h3>
          } @else {
            <button
              type="button"
              class="nav-group-title"
              [attr.aria-expanded]="isGroupOpen(group.title)"
              (click)="toggleGroup(group.title)"
            >
              {{ group.title }}
              <mat-icon>{{ isGroupOpen(group.title) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          }
          @if (isGroupOpen(group.title)) {
            @for (item of group.items; track item.link) {
              <ng-container *ngTemplateOutlet="navItem; context: { $implicit: item }"></ng-container>
            }
          }
        }
        @for (item of footerItems; track item.link) {
          <ng-container *ngTemplateOutlet="navItem; context: { $implicit: item }"></ng-container>
        }
        @if (user$ | async) {
          <a mat-list-item (click)="logOut()" routerLinkActive="mdc-list-item--activated"
             matTooltip="Log out" matTooltipPosition="right" [matTooltipDisabled]="!isRail">
            <mat-icon>exit_to_app</mat-icon>
            <span class="nav-label">Log out</span>
          </a>
        }
        <ng-template #navItem let-item let-draggable="draggable">
          <div class="nav-row" cdkDrag cdkDragLockAxis="y" [cdkDragDisabled]="!draggable">
            @if (draggable) {
              <mat-icon cdkDragHandle class="nav-grip" aria-hidden="true">drag_indicator</mat-icon>
            }
            <a
              mat-list-item
              [routerLink]="item.link"
              routerLinkActive="mdc-list-item--activated"
              [matTooltip]="item.name"
              matTooltipPosition="right"
              [matTooltipDisabled]="!isRail"
              (click)="closeOnSmall(sidenav)"
            >
              <mat-icon>{{ item.icon }}</mat-icon>
              <span class="nav-label">{{ item.name }}</span>
            </a>
            <button
              mat-icon-button
              type="button"
              class="nav-pin"
              [class.nav-pin--on]="isPinned(item.link)"
              [attr.aria-pressed]="isPinned(item.link)"
              [attr.aria-label]="(isPinned(item.link) ? 'Unpin ' : 'Pin ') + item.name"
              [matTooltip]="isPinned(item.link) ? 'Unpin' : 'Pin to top'"
              (click)="togglePin(item.link)"
            >
              <mat-icon>push_pin</mat-icon>
            </button>
          </div>
        </ng-template>
      </mat-nav-list>
      @if (filtering && !groupsView.length && !footerItems.length) {
        <p class="nav-empty">Nothing matches "{{ query }}".</p>
      }
    }
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button mat-icon-button (click)="sidenav.toggle()" class="mr-1">
        <mat-icon>menu</mat-icon>
      </button>
      <span>{{ env }}</span>
      <span class="page-title">{{ pageTitle }}</span>
      <span class="example-spacer"></span>

      @if (currentUser) {
        <button mat-icon-button (click)="openUserNotes()" matTooltip="My Notes">
          <mat-icon>note</mat-icon>
        </button>
      }

      <button mat-icon-button (click)="toggleTheme()" matTooltip="Toggle Theme">
        <mat-icon>{{ theme === 'dark' ? 'dark_mode' : 'wb_sunny' }}</mat-icon>
      </button>
    </mat-toolbar>
    <div class="p-6">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
